"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "citta-sant-angelo": {
    "4f16e85e": [{
      "hkey": "90eb4d85",
      "slug": "piano-della-cona",
      "name": "Piano della Cona",
      "primary": true,
      "skipSearch": false
    }],
    "cona": [{
      "hkey": "90eb4d85",
      "slug": "piano-della-cona",
      "name": "Piano della Cona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3dc2e7a1": [{
      "hkey": "2c33f571",
      "slug": "fonte-umano-san-martino-alta",
      "name": "Fonte Umano-San Martino Alta",
      "primary": true,
      "skipSearch": false
    }],
    "fonte-umano": [{
      "hkey": "2c33f571",
      "slug": "fonte-umano-san-martino-alta",
      "name": "Fonte Umano-San Martino Alta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f6531d02": [{
      "hkey": "2c33f571",
      "slug": "fonte-umano-san-martino-alta",
      "name": "Fonte Umano-San Martino Alta",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-alta": [{
      "hkey": "2c33f571",
      "slug": "fonte-umano-san-martino-alta",
      "name": "Fonte Umano-San Martino Alta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "citta-sant-angelo"
    }]
  }
};
exports["default"] = _default;